import { Component, OnInit } from '@angular/core';

/**
 * redirect root page to HISinOne portal
 */
@Component( {
    templateUrl: './erp-startpage.component.html'
} )
export class ErpStartpageComponent implements OnInit {
    ngOnInit() {
        window.location.href = '../../pages/cs/sys/portal/hisinoneStartPage.faces';
    }
}
